import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isDriverActive, resumeGuidedTourIfNeeded } from './runGuidedTour'
import { readTourSession } from './tourSession'

interface TourResumeEffectProps {
  onTourComplete?: () => void
}

/** Resumes an in-progress tour after route changes. */
export default function TourResumeEffect({ onTourComplete }: TourResumeEffectProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const resuming = useRef(false)

  useEffect(() => {
    if (isDriverActive()) return
    const session = readTourSession()
    if (!session || resuming.current) return

    resuming.current = true
    void resumeGuidedTourIfNeeded(
      navigate,
      location.pathname,
      location.search,
      onTourComplete,
    ).finally(() => {
      resuming.current = false
    })
  }, [location.pathname, location.search, navigate, onTourComplete])

  return null
}
